import { baseAPI } from "../../services/api";
import { transactionID } from "../../services/helpers";

export async function pixRechargeRequest({ msisdn, value, authToken }) {
  return baseAPI.post(
    "/v2/recharge",
    {
      MSISDN: msisdn,
      SMSISDN: msisdn,
      Value: value.toString(),
      cvv: 0,
      paymentId: 0,
      paymentType: "P",
      program: 0,
      transactionId: transactionID("ACI"),
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
}
